import { render, staticRenderFns } from "./passthrough.vue?vue&type=template&id=bcfd67ec"
import script from "./passthrough.vue?vue&type=script&lang=js"
export * from "./passthrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports